(function () {
  var isLoading = false;
  var nextPageUrl = null;
  var grid = null;
  var loadMoreBtn = null;
  var scrollBound = false;
  var throttleTimer = null;
  var loadedPages = 1;
  var onLoaded = null;
  var restored = false;
  var KEY = 'bigdex-scroll:' + location.pathname + location.search;

  function pageOf(url) {
    var m = /[?&]page=(\d+)/.exec(url || '');
    return m ? parseInt(m[1], 10) : 1;
  }

  /* What this tab had loaded, and where it was, for coming back to it. */
  var lastLink = null;

  function saveState() {
    try {
      var st = { pages: loadedPages, y: window.scrollY, at: Date.now() };
      if (lastLink) {
        st.href = lastLink.getAttribute('href');
        st.top = lastLink.getBoundingClientRect().top;
      }
      sessionStorage.setItem(KEY, JSON.stringify(st));
    } catch (e) {}
  }

  /* Put the product the shopper opened back where it was on screen. Card
     heights change as images load, so the product is a better landmark than
     a pixel count; the pixel count is the fallback. */
  function returnTo(st) {
    var card = null;
    if (st.href && grid) {
      var links = grid.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute('href') === st.href) {
          card = links[i];
          break;
        }
      }
    }
    if (card) {
      var top = card.getBoundingClientRect().top + window.scrollY;
      window.scrollTo(0, Math.max(0, top - (st.top || 0)));
    } else {
      window.scrollTo(0, st.y || 0);
    }
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function cameBack() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return Boolean(nav && nav.type === 'back_forward');
    } catch (e) {
      return false;
    }
  }

  /* Coming back to the list: load the pages that were showing, then return
     to the same spot. Only on Back, only within 30 minutes. */
  function restore() {
    if (restored) return;
    restored = true;
    var st = readState();
    if (!st || !cameBack() || Date.now() - st.at > 30 * 60 * 1000) return;
    var target = Math.min(st.pages || 1, 20);
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    function step() {
      if (loadedPages >= target || !nextPageUrl) {
        returnTo(st);
        /* Once more after images settle. */
        setTimeout(function () { returnTo(st); }, 600);
        return;
      }
      onLoaded = step;
      loadNextPage();
    }
    step();
  }

  function init() {
    if (loadMoreBtn) {
      loadMoreBtn.remove();
      loadMoreBtn = null;
    }
    isLoading = false;

    grid = document.getElementById('product-grid');
    if (!grid) return;

    loadedPages = pageOf(location.href);

    /* Find next page URL from pagination */
    nextPageUrl = getNextPageUrl();
    if (!nextPageUrl) return;

    /* Hide traditional pagination */
    var paginationWrappers = document.querySelectorAll('.pagination-wrapper');
    paginationWrappers.forEach(function (p) {
      p.style.display = 'none';
    });

    var reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion) {
      loadMoreBtn = document.createElement('button');
      loadMoreBtn.className = 'bigdex-load-more';
      loadMoreBtn.textContent = 'Load More';
      grid.parentNode.appendChild(loadMoreBtn);
      loadMoreBtn.addEventListener('click', function () {
        loadNextPage();
      });
      restore();
      return;
    }

    /* Bind scroll listener once */
    if (!scrollBound) {
      scrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    /* Check immediately in case grid bottom is already near viewport */
    if (!restored && cameBack()) {
      restore();
    } else {
      restored = true;
      setTimeout(checkAndLoad, 500);
    }
  }

  function getNextPageUrl() {
    /* Dawn names the "next" arrow .pagination__item--prev */
    var nextLink = document.querySelector(
      '.pagination__item--prev[aria-label]'
    );
    if (nextLink && nextLink.href) return nextLink.href;
    return null;
  }

  function onScroll() {
    if (throttleTimer) return;
    throttleTimer = setTimeout(function () {
      throttleTimer = null;
      checkAndLoad();
    }, 100);
  }

  function checkAndLoad() {
    if (!grid || !nextPageUrl || isLoading) return;

    var gridRect = grid.getBoundingClientRect();
    var triggerPoint = window.innerHeight + 600;

    /* Load when grid bottom is within 600px of viewport bottom */
    if (gridRect.bottom < triggerPoint) {
      loadNextPage();
    }
  }

  function createSkeletons(count) {
    var skeletons = [];
    for (var i = 0; i < count; i++) {
      var li = document.createElement('li');
      li.className = 'grid__item bigdex-skeleton';
      li.innerHTML =
        '<div class="bigdex-skeleton__card">' +
        '<div class="bigdex-skeleton__image"></div>' +
        '<div class="bigdex-skeleton__text"></div>' +
        '<div class="bigdex-skeleton__price"></div>' +
        '</div>';
      skeletons.push(li);
      grid.appendChild(li);
    }
    return skeletons;
  }

  function removeSkeletons(skeletons) {
    skeletons.forEach(function (el) {
      el.remove();
    });
  }

  function loadNextPage() {
    if (!nextPageUrl || isLoading) return;

    isLoading = true;

    if (loadMoreBtn) {
      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;
    }

    var skeletons = createSkeletons(4);
    var fetchUrl = nextPageUrl;

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newProducts = doc.querySelectorAll('#product-grid > li');

        removeSkeletons(skeletons);

        var currentCount = grid.querySelectorAll(
          ':scope > li:not(.bigdex-skeleton)'
        ).length;

        newProducts.forEach(function (item, index) {
          item.style.setProperty(
            '--animation-order',
            currentCount + index + 1
          );
          grid.appendChild(item);
        });

        /* Check fetched page for its next page link */
        var fetchedNextLink = doc.querySelector(
          '.pagination__item--prev[aria-label]'
        );
        if (fetchedNextLink && fetchedNextLink.getAttribute('href')) {
          var href = fetchedNextLink.getAttribute('href');
          if (href.indexOf('http') !== 0) {
            href = window.location.origin + href;
          }
          nextPageUrl = href;
        } else {
          nextPageUrl = null;
        }

        /* 26 Sep 2026: the address bar is NO LONGER changed to ?page=N.
           It used to be, so anything that re-read the address — going back
           from a product, closing a filter — showed page N on its own
           instead of the list the shopper was scrolling. Pages loaded so far
           are remembered for this tab instead; see saveState/restore.

           29 Sep 2026: counted, not read off the URL. Shop All now carries on
           from the Big Dex pages into the partner-shop pages, whose page
           numbers start again at 1, so the URL no longer says how much of
           the list is on screen. */
        loadedPages += 1;
        isLoading = false;

        if (loadMoreBtn) {
          if (nextPageUrl) {
            loadMoreBtn.textContent = 'Load More';
            loadMoreBtn.disabled = false;
          } else {
            loadMoreBtn.remove();
            loadMoreBtn = null;
          }
        }

        /* Coming back to the list: keep loading until it is as long as it was */
        if (onLoaded) {
          var cb = onLoaded;
          onLoaded = null;
          cb();
          return;
        }

        /* Check again immediately — if still near bottom, load next page too */
        if (nextPageUrl) {
          setTimeout(checkAndLoad, 200);
        }
      })
      .catch(function (err) {
        console.error('[BigDex Infinite Scroll]', err);
        removeSkeletons(skeletons);
        isLoading = false;
        if (loadMoreBtn) {
          loadMoreBtn.textContent = 'Load More';
          loadMoreBtn.disabled = false;
        }
      });
  }

  /* Initialize after DOM + deferred scripts are ready */
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  window.addEventListener('pagehide', saveState);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#product-grid a');
    if (a) {
      lastLink = a;
      saveState();
    }
  });

  onReady(function () {
    init();

    /* Re-initialize when Dawn's facets.js swaps the grid (filter/sort) */
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      var reinitTimer = null;
      new MutationObserver(function () {
        clearTimeout(reinitTimer);
        reinitTimer = setTimeout(init, 300);
      }).observe(container, { childList: true });
    }
  });
})();
